module.exports = __webpack_public_path__ + "img/freelancer-hg.0bc1a244.jpg";